
// Batch new-design JS (theme build)
const BN_VAR = {
  o:{4:52002055389551,8:52002055422319,16:52905924264303,24:53116276736367},
  u:{4:52002052440431,8:52002052473199,16:52905924919663,24:53116278538607},
  m:{4:52028164571503,8:52028164604271,16:52905925083503,24:53116277948783}
};
const packPrice={4:31.99,8:59.99,16:109.99,24:149.99};
function fq(b){b.parentElement.classList.toggle('open');b.querySelector('span').textContent=b.parentElement.classList.contains('open')?'−':'+'}
const BN_HANDLE={o:'original-4-pack',u:'unseasoned-4-pack',m:'mix-match'};
let _spCache={};
async function bnProduct(handle){
  try{
    if(!(handle in _spCache)){_spCache[handle]=await fetch('/products/'+handle+'.js').then(r=>r.json());}
    return _spCache[handle]||null;
  }catch(e){return null;}
}
async function bnSellingPlan(handle,variantId){
  var p=await bnProduct(handle);
  if(!p||!p.variants)return null;
  var v=p.variants.find(function(x){return x.id===variantId});
  if(v&&v.selling_plan_allocations&&v.selling_plan_allocations.length)return v.selling_plan_allocations[0].selling_plan_id;
  return null;
}
async function bnAddSmart(handle,id,isSub,props){
  var item={id:id,quantity:1,properties:props};
  if(isSub){var sp=await bnSellingPlan(handle,id);if(sp){item.selling_plan=sp;delete item.properties['Purchase'];}}
  bnAdd([item]);
}
function bnAdd(items){
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})})
    .then(r=>{ if(r.ok){
      if(typeof upcartRefreshCart==='function'){
        try{upcartRefreshCart();if(typeof upcartRegisterAddToCart==='function'){upcartRegisterAddToCart();}}catch(e){window.location.href='/cart';}
      } else {window.location.href='/cart';}
    } else {r.json().then(j=>alert(j.description||'Could not add to cart'));} });
}
// ---- homepage quick buy ----
let hb={sub:true,n:16};
function bmode(s){hb.sub=s;var a=document.getElementById('pt-sub'),b=document.getElementById('pt-one');if(a){a.classList.toggle('on',s);b.classList.toggle('on',!s);}bnRender();}
function bpick(n){hb.n=n;document.querySelectorAll('.packs .pk').forEach(p=>p.classList.toggle('on',+p.dataset.n===n));bnRender();}
function bnRender(){
  [4,8,16,24].forEach(n=>{var el=document.getElementById('pk'+n);if(el)el.textContent='$'+(packPrice[n]*(hb.sub?0.8:1)).toFixed(2);});
  var tot=packPrice[hb.n]*(hb.sub?0.8:1);
  var atc=document.getElementById('bh-atc');
  if(atc)atc.textContent=(hb.sub?'Start my Batch · $':'Add to Cart · $')+tot.toFixed(2)+(hb.sub?'/mo':'');
  var note=document.getElementById('bh-note');
  if(note)note.innerHTML='$'+(tot/hb.n).toFixed(2)+'/pouch'+(hb.sub?' · <b>free shipping</b> · skip or cancel anytime':' · free shipping on orders over $100');
  document.querySelectorAll('.packs .pk u').forEach(function(u){u.style.display=hb.sub?'block':'none'});
  var perks=document.getElementById('bh-perks');if(perks)perks.style.display=hb.sub?'block':'none';
}
function bnQuickAdd(){
  bnAddSmart(BN_HANDLE.o,BN_VAR.o[hb.n],hb.sub,{'Purchase':hb.sub?'Subscribe & Save 20%':'One-time'});
}
// ---- PDP ----
let fmode='mix',selN=16,psub=true;
function g2pick(t){var m=document.getElementById('g2main');if(m){m.src=t.src;document.querySelectorAll('.sn-thumbs img').forEach(i=>i.classList.remove('on'));t.classList.add('on');}}
function gpick(t){var m=document.getElementById('gmain');if(m){m.src=t.dataset.full||t.src;document.querySelectorAll('.thumbs img').forEach(i=>i.classList.remove('on'));t.classList.add('on');}}
function gstep(d){var th=[...document.querySelectorAll('.thumbs img')];var i=th.findIndex(t=>t.classList.contains('on'));gpick(th[(i+d+th.length)%th.length]);}
function setSub(v){psub=v;var s=document.getElementById('bc-sub'),o=document.getElementById('bc-one');if(s){s.classList.toggle('on',v);o.classList.toggle('on',!v);}calc();}
function bnImgUrl(u,w){
  if(!u)return u;
  return u.indexOf('?')>-1 ? (u+'&width='+w) : (u+'?width='+w);
}
// Rebuild the full PDP gallery (main image + thumbnails) for the selected flavor,
// so photos AND the nutrition-facts image always match the flavor being viewed.
function setFmode(m){fmode=m;
  ['mix','o','u'].forEach(k=>{var b=document.getElementById('fm-'+k);if(b)b.classList.toggle('on',k===m);});
  bnProduct(BN_HANDLE[m==='mix'?'m':m]).then(function(p){
    if(!p||fmode!==m)return;
    var imgs=(p.images&&p.images.length)?p.images:(p.featured_image?[p.featured_image]:[]);
    if(!imgs.length)return;
    var gm=document.getElementById('gmain');
    if(gm)gm.src=bnImgUrl(imgs[0],1200);
    var tw=document.querySelector('.thumbs');
    if(tw){
      tw.innerHTML=imgs.map(function(u,i){
        return '<img'+(i===0?' class="on"':' loading="lazy" decoding="async"')+' src="'+bnImgUrl(u,400)+'" data-full="'+bnImgUrl(u,1200)+'" alt="'+((p.title||'')+' image '+(i+1)).replace(/"/g,'')+'" onclick="gpick(this)">';
      }).join('');
    }
  });
  var fs=document.getElementById('fmsub');
  if(fs)fs.textContent=m==='mix'?'Half Original, half Unseasoned, packed for you.':m==='o'?'Slow-simmered in organic chicken broth, ready to eat.':'A clean base. Season it your way.';
  calc();}
function pickTier(el){selN=+el.dataset.n;calc()}
function calc(){
  var n=selN,one=packPrice[n],total=psub?one*0.8:one;
  document.querySelectorAll('.tier').forEach(t=>t.classList.toggle('on',+t.dataset.n===n));
  [4,8,16,24].forEach(k=>{var el=document.getElementById('sp'+k);if(el)el.textContent='$'+(packPrice[k]*(psub?0.8:1)).toFixed(2);});
  var pl=document.getElementById('ppl');
  if(pl)pl.textContent=n+' pouches · $'+(total/n).toFixed(2)+' per pouch'+(psub?' with Subscribe & Save':'');
  var bs=document.getElementById('bc-sub-price'),bo=document.getElementById('bc-one-price');
  if(bs)bs.textContent='$'+(one*0.8).toFixed(2);
  if(bo)bo.textContent='$'+one.toFixed(2);
  var atc=document.getElementById('atc');
  if(atc){atc.textContent='Add to Cart · '+n+' pouches · $'+total.toFixed(2)+(psub?' / mo':'');atc.disabled=false;}
}
function bnPdpAdd(){
  var f=fmode==='mix'?'m':fmode;
  bnAddSmart(BN_HANDLE[f],BN_VAR[f][selN],psub,{'Purchase':psub?'Subscribe & Save 20%':'One-time'});
}
function rhov(el){document.querySelectorAll('.rrow').forEach(r=>r.classList.remove('on'));el.classList.add('on');var im=document.getElementById('rimg');if(im){im.style.opacity=0;setTimeout(()=>{im.src=el.dataset.img;im.style.opacity=1;},140);}}
document.addEventListener('DOMContentLoaded',()=>{bnRender();calc();});
